import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { BefreiungErgebnis } from './../shared/entities/befreiungErgebnis';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../../appState/appStateStore.module';

@Component({
  selector: 'app-ergebnis',
  templateUrl: './ergebnis.component.html',
  styleUrls: ['./ergebnis.component.css']
})
export class ErgebnisComponent implements OnInit {
  ergebnis: BefreiungErgebnis;
  currentYear: number;

  constructor(private store: Store<AppState>, private router: Router) {
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit() {
    this.store.select(s => s.app.befreiungErgebnis)
      .subscribe(b => {
        this.ergebnis = b;
      });
  }

  doGoBackToSearch(event) {
    this.router.navigate(['/kvNummerSuche']);
  }
}



// WEBPACK FOOTER //
// ./src/app/befreiung/ergebnis/ergebnis.component.ts